import { AgentPerformancePanel } from './AgentPerformancePanel'
import { BestTimeToCallPanel } from './BestTimeToCallPanel'
import { TeamPerformancePanel } from './TeamPerformancePanel'

export const TeamPerformanceContent = () => {
   return (
      <div className="mt-4">
         <div className="flex flex-col gap-4 mb-4 xl:flex-row">
            <div className="xl:w-3/5">
               <TeamPerformancePanel />
            </div>
            <div className="xl:w-2/5">
               <BestTimeToCallPanel />
            </div>
         </div>
         <AgentPerformancePanel />
      </div>
   )
}
